import React from "react";
import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Grid";
import headerbar from "../assets/img/dgnamegen.png";
import CssBaseline from "@mui/material/CssBaseline";
//import { useTheme } from "@mui/material/styles";
//import Box from "@mui/material/Box";
//import useMediaQuery from "@mui/material/useMediaQuery";
import "../assets/styles/index.css";

const Header = props => {
  //const { genType } = props;
  //const theme = useTheme();
  //const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <AppBar
      position="sticky"
      sx={{
        bgcolor: "background.paper",
        boxShadow: 1,
        borderRadius: 1,
        p: 1,
      }}>
      <CssBaseline />
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="column">
        <Grid item justifyContent="center">
          <img className="headerbottomimg" src={headerbar} alt="Logo" />
        </Grid>
        {/*         <Grid>
          <Box sx={{ color: "#00000099", fontSize: "2.5vh" }}>
            <strong> {genType} NAME GENERATOR </strong>
          </Box>
        </Grid> */}
      </Grid>
    </AppBar>
  );
};

Header.propTypes = {};

export default Header;
